<template>
    <div>
        <div class="flex-column flex-fill" :class="[isFeatureMode ? 'd-none' : 'd-flex' ]">
            <div class="annotations-item panel-control-content d-flex flex-column flex-fill">
                <div class="row mb-3">
                    <div class="col-12">
                        <div class="btn-toolbar w-100 justify-content-center" role="toolbar" aria-label="">
                            <div class="btn-group btn-block" role="group" aria-label="Actions">
                                <button
                                    v-for="(action, key) in activeActions"
                                    :disabled="action.disabled()"
                                    :key="key"
                                    :title="action.title"
                                    @click.prevent="applyAction(key, $event)"
                                    type="button"
                                    class="btn btn-main min-w-auto mx-0"
                                    :class="{'d-flex align-items-center justify-content-center': !!action.image}"
                                    data-toggle="tooltip-city"
                                >
                                    <template v-if="action.icon">
                                        <i class="" :class="action.icon"></i>
                                    </template>
                                    <template v-else-if="action.image">
                                        <img :src="action.image" class="btn-image" />
                                    </template>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row flex-fill">
                    <div class="col">
                        <form autocomplete="off" data-vv-scope="form">
                            <div class="row">
                                <div class="col-12">
                                    <MaterialInput
                                        :disabled="readonlyFormItem"
                                        :readonly="editing || readonlyFormItem"
                                        type="text"
                                        class="city-form-group city-bg"
                                        id="input-title"
                                        name="title"
                                        v-model.trim="form.title"
                                        v-validate="'required'"
                                        :inputClasses="[{'is-invalid': fnHasError('title')}]"
                                        :error="fnFirstError('title')"
                                    >
                                        Título
                                    </MaterialInput>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <MaterialTextarea
                                        :readonly="readonlyFormItem"
                                        :disabled="editing || readonlyFormItem"
                                        class="city-form-group city-bg mb-md-0"
                                        id="input-description"
                                        name="description"
                                        v-model.trim="form.description"
                                        :rows="3"
                                        v-validate="''"
                                        :inputClasses="[{'is-invalid': fnHasError('description') }]"
                                        :error="fnFirstError('description')">
                                        Descrição
                                    </MaterialTextarea>
                                </div>
                            </div>
                            <div class="row geometries mt-3">
                                <div class="col-12">
                                    <hr class="my-2" />
                                    <div class="row geometries-actions">
                                        <div class="col-12 d-flex flex-nowrap align-items-center justify-content-between">
                                            <div class="">
                                                <span class="subtitle">Geometrias</span>
                                            </div>
                                            <div class="">
                                                <div class="btn-toolbar" role="toolbar" aria-label="">
                                                    <div class="btn-group" role="group" aria-label="Geometries Actions">
                                                        <button
                                                            v-for="(action, idx) in activeDrawControls"
                                                            :disabled="editing"
                                                            :key="idx"
                                                            :title="action.title"
                                                            @click.prevent="setMapInteraction(action)"
                                                            type="button"
                                                            class="btn min-w-auto"
                                                            :class="{'active': drawType === action.type}"
                                                            data-toggle="tooltip-city"
                                                        >
                                                            <template v-if="action.icon">
                                                                <i class="" :class="action.icon"></i>
                                                            </template>
                                                            <template v-if="action.img">
                                                                <img :src="action.img" alt="Tool" />
                                                            </template>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row geometries-list">
                                        <input type="hidden" name="geometries" v-model="recordFeatures" v-validate="'required'" />
                                        <div class="city-form-group mb-0 col-12" v-if="fnHasError('geometries')">
                                            <small class="invalid-feedback d-block">{{ txtNoValidGeometries }}</small>
                                        </div>
                                        <div class="col-12 pt-3" :class="{'text-center': !recordHasFeatures}">
                                            <template v-if="recordHasFeatures">
                                                <div class="row no-gutters">
                                                    <template v-for="(feature, idx) in recordFeatures">
                                                        <record-item-feature
                                                            :feature="feature"
                                                            :disabled="editing"
                                                            :controlsConfig="activeDrawControls"
                                                            :key="`feature-${idx}`"
                                                            :moduleCode="moduleCode"
                                                            :map="map"
                                                            :readonlyFormItem="readonlyFormItem"
                                                            @geometryHighlight="onGeometryHighlight"
                                                            @selectedFeature="onSelectedFeature"
                                                            @zoomToFeature="onZoomToFeature"
                                                            @removeFeature="onRemoveFeature"
                                                            />
                                                    </template>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <span class="small">{{ txtNoGeometries }}</span>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-control d-flex flex-column flex-fill" v-if="isFeatureMode">
            <div class="panel-control-content d-flex flex-column flex-fill">
                 <record-item-feature-form
                    :feature="selectedFeature"
                    :controlsConfig="activeDrawControls"
                    :moduleCode="moduleCode"
                    :readonlyFormItem="readonlyFormItem"
                    @save="onSaveFeature"
                    @back="onBackFeature" />
            </div>
        </div>
    </div>
</template>

<script>
    import {
        GEOM_PROPERTY,
        IS_CIRCLE_PROPERTY,
        RADIUS_PROPERTY,
        CENTER_PROPERTY,
        CIRCLE_POLYGON_GEOM_PROPERTY
    } from './../AnnotationConstants';
    import AnnotationMixin from './../AnnotationMixin';
    import {equalDeep} from '@config/utils';

    const INTERACTIONS = {
        DRAW: 'draw',
        MODIFY: 'modify',
        SNAP: 'snap',
    };

    let vars = {
        interactions: {}
    };

    export default {
        name: 'AnnotationRecordItem',
        mixins: [
            AnnotationMixin,
        ],
        components: {
            RecordItemFeature: () => import(/* webpackChunkName: "annotation-record-item-feature" */ './AnnotationRecordItemFeature'),
            RecordItemFeatureForm: () => import(/* webpackChunkName: "annotation-record-item-feature-form" */ './AnnotationRecordItemFeatureForm'),
        },
        props: {
            record: {
                type: Object,
                required: true,
                default: () => {},
            },
            moduleCode: {
                type: String,
                require: true,
            },
            reset: {
                type: Boolean,
                default: false,
            },
            map: {
                type: Object,
                require: true,
            },
            readonlyFormItem: {
                type: Boolean,
                default: true,
            },
            txtNoGeometries: {
                type: String,
                default: 'Adicione uma nova geometria',
            },
            txtNoValidGeometries: {
                type: String,
                default: 'Add at least one valid geometry',
            },
            txtConfirmLeaveSession: {
                type: String,
                default: 'Deseja abandonar a sessão de edição da anotação?',
            },
        },
        data() {
            return {
                selectedFeature: null,
                actions: {
                    back: {
                        title: 'Voltar às Anotações',
                        icon: 'fas fa-arrow-left',
                        active: () => {return true;},
                        disabled: () => {return this.editing;},
                    },
                    save: {
                        title: 'Salvar Anotação',
                        icon: 'fas fa-save',
                        active: () => {return true;},
                        disabled: () => {return this.editing;},
                    },
                    delete: {
                        title: 'Remover Anotação',
                        icon: 'fas fa-trash-alt',
                        active: () => {return true;},
                        disabled: () => {return this.editing;},
                    },
                    download: {
                        title: 'Exportar Anotação',
                        icon: 'fas fa-cloud-download-alt',
                        active: () => {return !this.recordProperties[this.temporaryProperty];},
                        disabled: () => {return this.editing || this.isRecordDirty || this.fnHasErrors();},
                    },
                    qgis: {
                        title: 'Exportar Anotação para QGIS',
                        image: this.assetsPathGlobal('icons/qgis.svg'),
                        active: () => {return !this.recordProperties[this.temporaryProperty];},
                        disabled: () => {return this.editing || this.isRecordDirty || this.fnHasErrors();},
                    },
                },
                drawType: undefined,
                drawing: false,
                originalFeature: null,
                originalRecord: null,
                recordSession: {
                    features: [],
                    properties: {},
                    style: {},
                    crs: {},
                    type: 'FeatureCollection',
                },
                form: {
                    title: null,
                    description: null,
                    visibility: true,
                }
            }
        },
        beforeMount () {
            this.copyValue(this.record);
        },
        mounted() {

        },
        computed: {
            recordProperties() {
                return this.recordSession.properties || {};
            },
            rid() {
                return this.recordProperties.id || null;
            },
            activeActions() {
                const filtered = Object.entries(this.actions).filter(([key, value]) => value.active());
                return Object.fromEntries(filtered);
            },
            recordFeatures() {
                return this.recordSession.features || [];
            },
            recordHasFeatures() {
                return this.recordFeatures.length>0;
            },
            isFeatureMode() {
                return !!this.selectedFeature;
            },
            selectedFeatureId() {
                return this.selectedFeature ? this.selectedFeature.properties.id : null;
            },
            editing() {
                return this.drawing;
            },
            isRecordDirty() {
                let originalRecord = this.removeEmpty(this.originalRecord);
                let recordSession = this.removeEmpty(this.recordSession);
                let form = this.removeEmpty(this.form);
                return !equalDeep(originalRecord, recordSession, ['style', 'selected'])
                    || !equalDeep(recordSession.properties, form);
            },
            // sourceId() {
            //     return `${this.layersProperties.source}-${this.rid}`;
            // },
            // layerId() {
            //     return `${this.layersProperties.layer}-${this.rid}`;
            // },
        },
        methods: {
            copyValue (record) {
                this.recordSession = record;
                this.originalRecord = JSON.parse(JSON.stringify(this.recordSession));
                this.form = Object.assign(this.form, this.recordProperties);
            },
            applyAction(key, evt) {
                this.hideTooltip();
                switch(key) {
                    case 'delete':
                        this.deleteRecord();
                        break;
                    case 'save':
                        this.saveRecord();
                        break;
                    case 'back':
                        this.backRecord();
                        break;
                    case 'download':
                        this.exportRecord();
                        break;
                    case 'qgis':
                        this.exportRecord(true);
                        break;
                };
            },
            deleteRecord: function() {
                this.$root.$emit('openConfirmation', {
                    id: null,
                    data: this.recordSession,
                    text: 'Deseja eliminar a Anotação?',
                    callback: (id, data) => {
                        this.resetMap();
                        this.$emit('delete', this.rid);
                    },
                });
            },
            saveRecord: function() {
                this.$validator.validateAll('form')
                .then(result => {
                    if(!result){
                        return false;
                    }
                    return true;
                }).then((res) => {
                    if(res) {
                        this.recordSession.properties = Object.assign({}, this.form);
                        this.resetMap();
                        this.$emit('save', this.recordSession);
                    }
                })
                .catch(error => {
                    this.showError(error);
                });
            },
            changeRecord: function() {
                this.$emit('update', {
                    id: this.rid,
                    record: this.recordSession,
                });
            },
            backRecord: function() {
                if(this.isRecordDirty) {
                    this.$root.$emit('openConfirmation', {
                        id: null,
                        data: this.recordSession,
                        text: this.txtConfirmLeaveSession,
                        callback: (id, data) => {
                            this.closeRecord();
                        },
                    });
                }else{
                    this.closeRecord();
                }
            },
            closeRecord() {
                this.resetMap();
                this.$emit('back', this.originalRecord);
            },
            exportRecord(toExternal=false) {
                this.$emit('download', {id: this.rid, external: toExternal});
            },
            addNewFeature(type, action) {
                this.drawing = true;
                const fid = this.generateId();
                let properties = {
                    id: fid,
                    isValidFeature: false,
                    canEdit: false,
                    selected: true,
                    geometryTitle: action ? action.title : null,
                };
                if(type.toLowerCase() == 'circle') {
                    type =  'Point';
                    properties[IS_CIRCLE_PROPERTY] = true;
                    properties[CENTER_PROPERTY] = null;
                    properties[RADIUS_PROPERTY] = null;
                    // properties[CIRCLE_POLYGON_GEOM_PROPERTY] = null;
                }

                let feature = {
                    type: 'Feature',
                    geometry: {
                        type,
                        coordinates: [],
                    },
                    properties,
                    style: {},
                };
                feature.properties[this.temporaryProperty] = true;
                this.recordFeatures.push(feature);
                this.onSelectedFeature(null, feature);
            },
            onRemoveFeature: function(fid) {
                this.$root.$emit('openConfirmation', {
                    id: fid,
                    data: this.recordSession,
                    text: 'Deseja eliminar a geometria da Anotação?',
                    callback: (id, data) => {
                        this.removeFeature(id);
                    },
                });
            },
            removeFeature: function(fid) {
                let idx = this.recordFeatures.findIndex(f => f.properties.id === fid);
                if(idx != -1){
                    this.recordFeatures.splice(idx, 1);
                }
            },
            onZoomToFeature(fid) {
                let extent = this.getFeaturesExtent([this.recordFeature(fid)]);
                if(extent) {
                    const _map = this.map;
                    if(_map) {
                        _map.zoomToExtent(_map.scaleExtent(extent, this.zoomToBoundsScale), this.zoomToBoundsDuration);
                    }
                }
            },
            onSaveFeature(feature) {
                let properties = feature.properties || {};
                let fid = properties.id;
                if(fid) {
                    delete properties[this.temporaryProperty];
                }
                this.onUnselectedFeature();
            },
            onBackFeature(feature) {
                let properties = feature.properties || {};
                let fid = properties.id;
                if(fid && properties[this.temporaryProperty]) {
                    this.removeFeature(fid);
                }
                let feat = this.recordFeature(this.selectedFeatureId);
                if(feat) {
                    feat = Object.assign(feat, this.originalFeature);
                }
                this.onUnselectedFeature();
            },
            onSelectedFeature(fid, feature = null) {
                feature = feature ? feature : this.recordFeature(fid);
                if(feature.style){
                    feature.style.highlight = false;
                }
                this.originalFeature = JSON.parse(JSON.stringify(feature));

                feature.properties.selected = true;
                // this.selectedFeature.properties.canEdit = true;

                this.selectedFeature = feature;

                this.setMapInteraction(null, INTERACTIONS.MODIFY);
            },
            onUnselectedFeature() {
                this.originalFeature = null;
                this.resetMap();
                let feat = this.recordFeature(this.selectedFeatureId);
                if(feat) {
                    feat.properties.selected = false;
                }
                // feat.properties.canEdit = false;
                this.selectedFeature = null;
            },
            onGeometryHighlight(params) {
                this.$emit('geometryHighlight', params);
            },
            recordFeature(fid) {
                return this.recordFeatures.find(f => f.properties.id === fid);
            },
            resetMap: function() {
                const _map = this.map;
                if(_map) {
                    this.resetDrawFeatures();
                    this.removeMapInteractions();
                    this.drawType = undefined;
                    this.drawing = false;
                }
            },
            setMapInteraction(action, key = INTERACTIONS.DRAW) {
                this.hideTooltip();
                let _map = this.map;
                if(_map) {
                    this.resetDrawFeatures();
                    let features = this.features();
                    let sourceId = this.sourceId;
                    let _source = _map.getSource(sourceId);
                    const geomType = action ? action.geometryType : null;
                    const type = action ? action.type : null;
                    this.removeMapInteraction(key);
                    if(key == INTERACTIONS.DRAW) {
                        let geometryFunction;
                        const draw = _map.createDraw({
                            features: features,
                            type: geomType,
                            geometryFunction: geometryFunction,
                        });
                        draw.on('drawstart' /*DrawEventType.DRAWSTART*/, (evt) => {
                            this.resetDrawFeatures();
                            let _feature = this.selectedFeature;
                            _feature.geometry.coordinates = [];
                            _feature.properties.isValidFeature = false;
                        });
                        draw.on('drawend' /*DrawEventType.DRAWEND*/, (evt) => {
                            let feature = evt.feature;
                            this.updateFeatureAfterDraw(feature);
                        });
                        draw.setActive(false);
                        _map.addInteraction(draw);
                        vars.interactions[key] = draw;
                        this.drawType = type;
                        this.addNewFeature(type, action);

                    }else if(key == INTERACTIONS.MODIFY) {
                        if(_source) {
                            let feat = _source.getFeatureById(this.selectedFeatureId);
                            if(feat) {
                                features.push(feat);
                                const modify = _map.createModify({
                                    features: features,
                                    pixelTolerance: 50,
                                });
                                modify.on('modifystart', function (evt) {
                                });
                                modify.on('modifyend', (evt) => {
                                    let features = evt.features;
                                    if(features.getLength()>0) {
                                        let feature = features.item(0);
                                        this.updateFeatureAfterDraw(feature);
                                    }
                                });
                                modify.setActive(false);
                                _map.addInteraction(modify);
                                vars.interactions[INTERACTIONS.MODIFY] = modify;
                            }
                        }
                    }
                    if(key) {
                        this.removeMapInteraction(INTERACTIONS.SNAP);
                        if(_source) {
                            const snap = _map.createSnap({
                                source: _source,
                            });
                            snap.setActive(false);
                            _map.addInteraction(snap);
                            vars.interactions[INTERACTIONS.SNAP] = snap;
                        }
                    }
                    this.setActiveMapInteractions(true);
                }
            },
            setActiveMapInteractions: function(flag, keys='all'){
                let _map = this.map;
                if(_map) {
                    for (let key in vars.interactions) {
                        if(keys == 'all' || keys.includes(key)){
                            let interaction = vars.interactions[key];
                            if(interaction){
                                interaction.setActive(flag);
                            }
                        }
                    }
                }
            },
            removeMapInteractions: function(keys='all'){
                let _map = this.map;
                if(_map) {
                    for (let key in vars.interactions) {
                        if(keys == 'all' || keys.includes(key)){
                            this.removeMapInteraction(key);
                        }
                    }
                }
            },
            removeMapInteraction: function(key) {
                let _map = this.map;
                if(_map) {
                    let interaction = vars.interactions[key];
                    if(interaction){
                        interaction.setActive(false);
                        _map.removeInteraction(interaction);
                    }
                    // this.$set(vars.interactions, key, null);
                    vars.interactions[key] = null;
                }
            },
            updateFeatureAfterDraw: function(feature) {
                let geometry = feature.getGeometry();
                let geomType = geometry.getType().toLowerCase();

                let _feature = this.selectedFeature;
                _feature.properties.isValidFeature = true;
                _feature.properties[GEOM_PROPERTY] = geomType;
                if(geomType === 'circle') {
                    let center = geometry.getCenter();
                    let radius = geometry.getRadius();
                    // let _polygonGeom = fromCircle(geometry);
                    // _feature.properties[CIRCLE_POLYGON_GEOM_PROPERTY] = JSON.parse(new GeoJSON().writeGeometry(_polygonGeom));
                    _feature.properties[RADIUS_PROPERTY] = radius;
                    _feature.properties[CENTER_PROPERTY] = center;
                    _feature.geometry.coordinates = [...center];
                }else{
                    _feature.geometry.coordinates = [...geometry.getCoordinates()];
                }
            },
            removeEmpty: function(obj) {
                return Object.entries(obj)
                    .filter(([_, v]) => v != null)
                    .reduce(
                    (acc, [k, v]) => ({ ...acc, [k]: v === Object(v) ? this.removeEmpty(v) : v }),
                    {}
                    );
            },
        },
        watch: {
            recordFeatures: {
                immediate: false,
                deep: true,
                handler(value, oldVal) {
                    this.changeRecord();
                },
            },
            reset: {
                immediate: false,
                handler(value, oldVal) {
                    if(value){
                        this.onUnselectedFeature();
                    }
                },
            },
        },
    }
</script>

<style scoped lang="scss">
    .btn.active {
        color: #212529;
        background-color: #e2e6ea;
        border-color: #dae0e5;
    }
    .btn .btn-image {
        width: 14px;
    }
</style>